import { NotificationsContextProps } from 'providers/Notifications/Notifications.types';
import { useNotificationsContext } from 'src/providers/Notifications/NotificationsContext';

export const useNotifications = (): NotificationsContextProps => useNotificationsContext();
